import { useMutation } from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';

import { mutationCreateOneTalentProfile, queryGetUser } from '@itp/prisma-talent/gql';

export function useCreateTalentProfile() {
  const { user } = useAuth0();

  const [create] = useMutation(mutationCreateOneTalentProfile, {
    context: {
      headers: {
        'tp-domain': 'talent',
      },
    },
    refetchQueries: () => [
      {
        query: queryGetUser,
      },
    ],
  });

  const createTalentProfile = async () =>
    await create({
      variables: {
        data: {
          email: user?.email,
          profileName: user?.name.includes('@') ? '' : user?.name,
        },
      },
    });

  return { createTalentProfile };
}
